import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    background: ",
        ";\n    border: 1px solid ",
        ";\n    box-shadow: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button } from "@miro-site/core";
import { transparentize } from "polished";
import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import TransparentButton from "../../button/TransparentButton";
import SecondaryLink from "../../link/SecondaryLink";
var ActionsOverlayBase = function(param) {
    var metadataId = param.metadataId, templateActions = param.templateActions, templatePagePath = param.templatePagePath, className = param.className, onMoreInfoClick = param.onMoreInfoClick, previewButton = param.previewButton, actionButtonProps = param.actionButtonProps, isVisible = param.isVisible;
    var defaultPreviewButton = /*#__PURE__*/ _jsx(TransparentButton, {
        $size: "small",
        href: templatePagePath,
        onFocus: function() {
            return setOverlayVisible(true);
        },
        onBlur: function() {
            return setOverlayVisible(false);
        },
        children: templateActions.PREVIEW
    });
    var ref = useState(isVisible), isOverlayVisible = ref[0], setOverlayVisible = ref[1];
    useEffect(function() {
        setOverlayVisible(isVisible);
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ _jsx(Box, {
        "data-track-place": "actions-overlay",
        className: className,
        $styles: {
            position: "absolute",
            top: "0",
            right: "0",
            bottom: "0",
            left: "0",
            width: "100%",
            height: "100%",
            zIndex: 2,
            background: "primaryWhite",
            borderRadius: [
                8,
                16,
                16,
                16
            ],
            transition: "opacity 250ms, visibility 250ms",
            opacity: isOverlayVisible ? 1 : 0,
            pointerEvents: isOverlayVisible ? "all" : "none"
        },
        children: /*#__PURE__*/ _jsxs(Box, {
            $styles: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%"
            },
            children: [
                actionButtonProps ? /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
                    "data-track-id": "use-template",
                    "data-template-id": metadataId,
                    $buttonType: "primary",
                    $size: "small",
                    $mr: 12,
                    onFocus: function() {
                        return setOverlayVisible(true);
                    },
                    onBlur: function() {
                        return setOverlayVisible(false);
                    }
                }, actionButtonProps), {
                    children: actionButtonProps.children || templateActions.USE_TEMPLATE
                })) : null,
                previewButton ? previewButton(defaultPreviewButton) : defaultPreviewButton,
                /*#__PURE__*/ _jsx(SecondaryLink, {
                    $isDashed: true,
                    onClick: onMoreInfoClick,
                    $styles: {
                        position: "absolute",
                        right: 20,
                        bottom: 25
                    },
                    "data-testid": "more-info-button",
                    onFocus: function() {
                        return setOverlayVisible(true);
                    },
                    onBlur: function() {
                        return setOverlayVisible(false);
                    },
                    children: templateActions.SHOW_MORE_INFO
                })
            ]
        })
    });
};
var ActionsOverlay = styled(ActionsOverlayBase).withConfig({
    componentId: "sc-2194ff53-0"
})(function(param) {
    var theme = param.theme;
    return css(_templateObject(), transparentize(0.05, theme.colors.primaryWhite), theme.colors.grey, theme.templates.elevation.overlay);
});
export default ActionsOverlay;
